<mat-expansion-panel
  class="expandable-panel py-5 {{ configStyle.colorClass }}"
  (opened)="(expanded)"
  (closed)="(!expanded)"
>
  <mat-expansion-panel-header class="{{ configStyle.colorClass }}">
    <mat-panel-title>
      {{ configStyle.title | translate }}
      <br />
      {{ configStyle.subTitle | translate }}
      <div *ngIf="!configStyle.title && !configStyle.subTitle">
        <div class="vi-logo-img">
          <img src="./assets/img/viessmann-white.svg" alt="Viessmann" />
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div
    *ngIf="configStyle.isRemote; else vorOrt"
    class="text-sm text-white px-4 py-3 leading-relaxed text-center"
    [ngStyle]="{ 'background-color': configStyle.colorClass }"
  >
    <ul>
      <h2 class="text-2xl text-white pt-3 border-t border-black">
        {{ '+ADDITIONAL.SERVICE.FEATURE.REMOTE' | translate }}
      </h2>
      <li class="text-white mb-1" *ngFor="let remote of remoteDescription">
        {{ remote | translate }}
      </li>
    </ul>
  </div>
  <ng-template #vorOrt>
    <div
      class="text-sm text-white px-4 py-3 leading-relaxed text-center"
      [ngStyle]="{ 'background-color': configStyle.colorClass }"
    >
      <ul>
        <h2 class="text-2xl text-white pt-3 border-t border-black">
          {{ '+ADDITIONAL.SERVICE.FEATURE.SUBURB' | translate }}
        </h2>
        <li class="text-white mb-1" *ngFor="let vorort of vorOrtDescription">
          {{ vorort | translate }}
        </li>
      </ul>
    </div>
  </ng-template>
</mat-expansion-panel>
